<template>
  <vk-modal
      class="MODAL w-100"
      v-if="isOpen"
      :is-open="isOpen"
      :has-close-icon="closeIcon"
      @close="$emit('close')">
    <vk-modal-body>
      <vk-modal-header :class="['bd-b-gray40', { 'p-l-6': closeIcon } ]" class="text-center c-gray60">
      </vk-modal-header>
      <vk-modal-content class="d-flex jc-center p-0 w-100">
        <div class="bg-white">
          <div class="p-4:d p-1:mo">
            <img
                class="IMAGE"
                :src="image"
            />
          </div>
        </div>
      </vk-modal-content>
      <vk-modal-footer class="d-flex jc-end w-100">
        <div>
          <button @click="$emit('close')" class="m-t-2 p-x-4 m-x-auto btn">
            Close
          </button>
        </div>
      </vk-modal-footer>
    </vk-modal-body>
  </vk-modal>
</template>

<script>
import SlidingModal from '@/views/Dashboard/components/SlidingModal';

export default {
  name: 'image-modal',
  components: {
    SlidingModal,
  },
  props: {
    isOpen: Boolean,
    closeIcon: {
      type: Boolean,
      default: true,
    },
    image: {
      type: String,
      required: true,
    },
  },
};
</script>
<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools.scss";
  .MODAL {
    @include mobile-only() {
      top: 100px;
    }
  }
  .IMAGE {
    height: 100%;
    width: 100%;
    object-fit:contain;
  }
</style>
